(() => {
  'use strict';
  // Variant picker: keep product-card price/availability updates
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-picker]');
    if (!select) return;
    const card = select.closest('[data-product-card]');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    const price = card.querySelector('[data-variant-price]');
    const compare = card.querySelector('[data-compare-price]');
    if (price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    const button = card.querySelector('[name="add"]');
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel; }
  });
  // Close mobile menu on Escape
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
})();
